import React from 'react';

type Props = {
  children: React.ReactNode;
  disablePadding?: boolean;
}

const DialogContent:React.FC<Props> = ({ children, disablePadding }) => {
  return (
    <div className={`flex-grow relative overflow-y-auto ${disablePadding ? 'p-0' : 'p-4'}`}>{children}</div>
  )
}

export default DialogContent;
